// Level milestone crests and the champion trophy (art in public/assets/rewards).
export const MILESTONES = [5, 10, 20, 30, 50];
export const crestSrc = (m) => `/assets/rewards/crest_${m}.png`;
export const TROPHY_SRC = "/assets/rewards/champion_trophy.png";
// the highest milestone this level has reached, or null below level 5
export const crestFor = (level) => [...MILESTONES].reverse().find((m) => level >= m) || null;
